module.exports = __webpack_public_path__ + "static/media/pci_dss.9bcc42f5.png";